export default __webpack_public_path__ + "static/media/aiFaceInActive.eb8f8387.svg";